import { ReactElement, useMemo } from 'react';
import { useListAssetGroupsQuery } from '@casops/store/apis/assetGroupsApi';
import BadgeList from '@cas/components/tables/cells/badge-list/BadgeList';
import { EmptyCell } from '../../formatters/genericFormatters';

interface AssetGroupCellRendererProps {
  value: number[];
}

export function AssetGroupCellRenderer({
  value,
}: AssetGroupCellRendererProps): ReactElement | string {
  const { data: assetGroups } = useListAssetGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  const vehicleGroups = useMemo<string[]>(() => {
    if (assetGroups && value) {
      const orderedGroups: string[] = [];

      value.forEach(id => {
        const match = assetGroups.find(g => g.id === id);
        if (match && match.name) {
          orderedGroups.push(match.name);
        }
      });

      // Enforce alphabetical order.
      return orderedGroups.sort((a, b) => a.localeCompare(b));
    }

    return [];
  }, [value, assetGroups]);

  return vehicleGroups.length ? <BadgeList items={vehicleGroups} /> : EmptyCell;
}

export default AssetGroupCellRenderer;
